module.exports = __webpack_public_path__ + "img/linea_logo.64209303.svg";